import * as types from '../../action-types';
import {getSingleLanguage as initialState } from "../../initialState";

const getSingleLanguage = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_SINGLE_LANGUAGE_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_SINGLE_LANGUAGE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_SINGLE_LANGUAGE_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_SINGLE_LANGUAGE_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getSingleLanguage;
